import { ImageOff } from "lucide-react";
import { assetUrl } from "@/lib/assets";
import { cn } from "@/lib/utils";

export function PluckThumbnail({
	assetId,
	alt,
	className,
}: {
	alt: string;
	assetId: string | null;
	className?: string;
}) {
	if (!assetId) {
		return (
			<div
				className={cn(
					"flex items-center justify-center bg-muted text-muted-foreground",
					className
				)}
			>
				<ImageOff className="size-5" />
			</div>
		);
	}
	return (
		<img
			alt={alt}
			className={cn("object-contain", className)}
			decoding="async"
			loading="lazy"
			src={assetUrl(assetId)}
		/>
	);
}
